jQuery(document).on("change", '[data-behaviour~="navigate-on-change"]', function () {
  var value = jQuery(this).val();
  var targetPath = jQuery(this).data("path").replace("%{value}", value);

  // Submit using a form so responsive preview's <base> triggers page loads in the desired target
  jQuery("<form>").attr("action", targetPath).attr("method", "GET").appendTo("body").trigger("submit");
});
